import React, { useEffect } from "react";
import NavBar from "../components/Navbar";
//import { getClientsList} from "@/store/actions";
import { useStateContext } from "../Contexts/ContextProvider";
import ThemeSettings from "../components/themeSettings";
import { useLocation, Outlet } from "react-router-dom";
import Footer from "../components/common/footer";
import MantineImage from "../components/mantine/image";
import arrowImage from "../assets/images/jb-dark.svg";
import OverlayLoader from "../components/mantine/overlayloader";
const DefaultLayout = (props: any) => {

    const location = useLocation();
    const { setCurrentPrimaryColor, themeSettings, currentOrientation, setCurrentOrientation, setCurrentSecondaryColor, setCurrentTerritoryColor, setCurrentBgImage, currentBgImage, SetOpenSidebar } = useStateContext();
    const defaultPageRoute = location?.pathname === '/' ||
        location?.pathname === '/register' ||
        location?.pathname === '/forgotpassword' ||
        location?.pathname === '/activateaccount' ||
        location?.pathname === '/resetpassword' ||
        location?.pathname === '/verify'
        ;

    useEffect(() => {
        if (typeof localStorage !== 'undefined') {
            const currentThemeColorPrimary = localStorage.getItem("colorModePrimary");
            const currentThemeColorSecondary = localStorage.getItem("colorModeSecondary");
            const currentThemeColorTerritory = localStorage.getItem("colorModeTerritory");
            const currentThemeOrientation = localStorage.getItem("orientation");
            const currentBgImages = localStorage.getItem("currentImg");
            const currentSideIcon = localStorage.getItem("currentIconType");
            if (currentThemeColorPrimary || currentThemeOrientation || currentThemeColorSecondary || currentThemeColorTerritory || currentBgImage || currentSideIcon) {
                setCurrentPrimaryColor(currentThemeColorPrimary);
                setCurrentSecondaryColor(currentThemeColorSecondary);
                setCurrentTerritoryColor(currentThemeColorTerritory);
                setCurrentBgImage(currentBgImages)
                setCurrentOrientation(currentThemeOrientation);
                SetOpenSidebar(currentSideIcon);
            }
        }
    }, [setCurrentPrimaryColor, setCurrentSecondaryColor, setCurrentTerritoryColor, setCurrentOrientation, setCurrentSecondaryColor, setCurrentTerritoryColor, setCurrentBgImage, SetOpenSidebar]);
    useEffect(() => {
        if (defaultPageRoute) localStorage.clear();
    }, [defaultPageRoute])

    const userRoleId = typeof window !== 'undefined' ? localStorage.getItem('userRoleId') : null;
    return (
        <>
            {defaultPageRoute ? (
                <Outlet />
            ) : <>
                <NavBar orientation={currentOrientation}>
                    <Outlet />
                    {userRoleId === '2' && (
                        <MantineImage
                            src={arrowImage}
                            alt="img-dark-arrow"
                            style={{
                                position: "absolute",
                                bottom: "54px",
                                right: "10px",
                                width: "100px",
                                height: "50px",
                                opacity: 1,
                            }}
                        />
                    )}

                </NavBar>
                {themeSettings && <ThemeSettings />}
                <Footer />
            </>
            }
            <OverlayLoader />
        </>
    );
};
export default DefaultLayout;